module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('SubHeader', {
    attrs: {
      "page": _vm.currentRole.title
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "open-position-content"
  }, [_c('div', {
    staticClass: "open-position-content-desc block-el"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.currentRole.description)
    }
  }), _vm._v(" "), _vm._l((_vm.currentRole.sections), function(section) {
    return _c('div', {
      staticClass: "open-position-content-sections"
    }, [_c('div', {
      staticClass: "open-position-content-section-heading"
    }, [_vm._v("\n          " + _vm._s(section.heading) + "\n        ")]), _vm._v(" "), (section.textContent) ? _c('div', {
      staticClass: "open-position-content-section-content",
      domProps: {
        "innerHTML": _vm._s(section.textContent)
      }
    }) : _vm._e(), _vm._v(" "), _vm._l((section.bullets), function(bullet) {
      return _c('span', {
        staticClass: "open-position-content-section-content-bullet"
      }, [_c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (bullet.type == 'heading'),
          expression: "bullet.type == 'heading'"
        }],
        staticClass: "bullet-heading"
      }, [_vm._v(_vm._s(bullet.content))]), _vm._v(" "), _c('span', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (bullet.type == 'bullet'),
          expression: "bullet.type == 'bullet'"
        }],
        staticClass: "bullet-list-item"
      }, [_c('i', {
        staticClass: "fa fa-circle-thin"
      }), _vm._v(" "), _c('label', [_vm._v(_vm._s(bullet.content))])])])
    })], 2)
  }), _vm._v(" "), _c('a', {
    staticClass: "apply-now-button",
    attrs: {
      "href": "#contact-footer"
    },
    on: {
      "click": _vm.resetScroll
    }
  }, [_vm._v("Apply Now")]), _vm._v(" "), _c('div', {
    staticClass: "apply-now-text"
  }, [_vm._v("\n        Apply now by filling out our contact form, or send an email to hola at mikmak dot tv\n      ")])], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e5af926c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/OpenPositions.vue
// module id = 504
// module chunks = 0